import { render, staticRenderFns } from "./AddAlarm.vue?vue&type=template&id=27d17016&scoped=true&"
import script from "./AddAlarm.vue?vue&type=script&lang=ts&"
export * from "./AddAlarm.vue?vue&type=script&lang=ts&"
import style0 from "./AddAlarm.vue?vue&type=style&index=0&id=27d17016&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d17016",
  null
  
)

component.options.__file = "AddAlarm.vue"
export default component.exports